import { BDCheckboxFilter, BDRadioFilter, BDSliderFilter } from '@brother-apps/brother-dealerapp-shared-lib';

import { Injectable } from '@angular/core';

@Injectable()
export class BDCPConstsService {

    public customerModeOnImageSource = 'assets/images/customer_mode_switch_on.png';
    public customerModeOffImageSource = 'assets/images/customer_mode_switch_off.png';

    public blockedAlternativeTypeNames = [
        'Büromaterial & Schreibwaren',
        'POS-Geräte',
        'Tintenpatronen',
        'Toner',
        'Zubehör Drucker',
        'Zubehör Multifunktionsgeräte',
        'Zubehör Scanner'
    ];

    public productCategoryMap = {
        'labeler': 'Beschriftungsgeräte',
        'mfc': 'MFC/DCP',
        'scanner': 'Scanner',
        'printer': 'Drucker',
        'fax': 'Faxgeräte',
        'other': 'Sonstige',
        'supply': 'Verbrauchsmaterial',
        'accessory': 'Zubehör'
    };

    public scannerToDisplay = {
        'minScanVolume': (v: number) => `Tägl. Scanvolumen: min ${v}`,
        'maxPaperFeedVolume': (v: number) => `Papiereinzug: bis zu ${v} Blätter`,
        'connections': (v: string) => this.connectionsMap[v],
        'scanToFunctions': (v: string) => this.scanToFunctionsMap[v],
        'scanToPcFormats': (v: string) => this.scanToPcFormatsMap[v],
        'oneTouchFunction': () => 'Scannen über Taste am Gerät',
        'scanTouchScreen': () => 'Touchscreen-Benutzerführung',
        'scanDuplex': () => 'Duplex',
        'automaticFormatRecognition': () => 'Automatische Formaterkennung',
        'paperFeedViaUltrasound': () => 'Ultraschall Einzugserkennung',
        'sideStraightening': () => 'Automatische Seitenbegradigung',
        'scanOcr': () => 'OCR-Texterkennung',
        'imageRotation': () => 'Automatische Bilddrehung',
        'skipEmptyPage': () => 'Leere Seiten überspringen'
    };

    public printerToDisplay = {
        'printVolumeOpt': (v: number) => `Mtl. Druckvolumen: ${v}`,
        'minPrintSpeed': (v: number) => `Min. Druckgeschwindigkeit: ${v} Seiten/Min`,
        'minTotalPaperFeedNum': (v: number) => `Anzahl Papierzufuhr: ${v}`,
        'printTechnology': (v: string) => this.printTechnologyMap[v],
        'connections': (v: string) => this.connectionsMap[v],
        'printFormats': (v: string) => v.toUpperCase(),
        'printerLanguages': (v: string) => this.printerLanguageMap[v],
        'warrantyOnSite3Years': () => '3 Jahre vor Ort',
        'printAirbag': () => 'PrintAirBag',
        'funcColorPrint': () => 'Farbdruck',
        'duplexPrint': () => 'Duplex-Druck',
        'touchDisplay': () => 'Touch-Display'
    };

    public mfcToDisplay = {
        'printVolumeOpt': (v: number) => `Mtl. Druckvolumen: ${v}`,
        'minScanVolume': (v: number) => `Tägl. Scanvolumen: min: ${v}`,
        'minTotalPaperFeedNum': (v: number) => `Anzahl Papierzufuhr: ${v}`,
        'printTechnology': (v: string) => this.printTechnologyMap[v],
        'minPrintSpeed': (v: number) => `Min. Druckgeschwindigkeit: ${v} Seiten/Min`,
        'connections': (v: string) => this.connectionsMap[v],
        'printFormats': (v: string) => v.toUpperCase(),
        'printerLanguages': (v: string) => this.printerLanguageMap[v],
        'warrantyOnSite3Years': () => '3 Jahre vor Ort Garantie',
        'printAirbag': () => 'PrintAirBag',
        'funcColorPrint': () => 'Farbdruck',
        'funcFax': () => 'Faxen',
        'duplexPrint': () => 'Duplex-Druck',
        'touchDisplay': () => 'Touch-Display'
    };

    public labelerToDisplay = {
        'labelWidth': (v: number) => `Labelbreite: ${v} mm`,
        'keyboard': (v: string) => `Keyboard: ${v}`,
        'productDomain': (v: string) => this.productDomainMap[v],
        'connections': (v: string) => this.connectionsMap[v],
        'printBarcode': () => 'Bardcodedruck',
        'mobileFunctions': () => 'Mobile Nutzung',
        'networkAdapterInclusive': () => 'Netzadapter inklusive'
    };

    public faxToDisplay = {};

    public possibleLabelerQueryParams = {
        'productCategory': () => 'labeler',
        'productDomain': (filter: BDCheckboxFilter) => this.productDomainMap[filter.label],
        'labelWidth': (filter: BDSliderFilter) => filter.value,
        'keyboard': (filter: BDCheckboxFilter) => filter.label.toLowerCase(),
        'connections': (filter: BDCheckboxFilter) => this.connectionsMap[filter.label],
        'printBarcode': (filter: BDCheckboxFilter) => filter.selected ? 'true' : 'false',
        'mobileFunctions': (filter: BDCheckboxFilter) => filter.selected ? 'true' : 'false',
        'networkAdapterInclusive': (filter: BDCheckboxFilter) => filter.selected ? 'true' : 'false'
    };

    public possibleMfcQueryParams = {
        'productCategory': () => 'mfc',
        'printTechnology': (filter: BDCheckboxFilter) => this.printTechnologyMap[filter.label],
        'printVolumeOpt': (filter: BDSliderFilter) => filter.value,
        'minPrintSpeed': (filter: BDSliderFilter) => filter.value,
        'minScanVolume': (filter: BDSliderFilter) => filter.value,
        'minTotalPaperFeedNum': (filter: BDRadioFilter) => filter.label,
        'connections': (filter: BDCheckboxFilter) => this.connectionsMap[filter.label],
        'printFormats': (filter: BDCheckboxFilter) => filter.label.toLowerCase(),
        'printerLanguages': (filter: BDCheckboxFilter) => this.printerLanguageMap[filter.label],
        'warrantyOnSite3Years': (filter: BDCheckboxFilter) => filter.selected ? 'true' : 'false',
        'printAirbag': (filter: BDCheckboxFilter) => filter.selected ? 'true' : 'false',
        'funcColorPrint': (filter: BDCheckboxFilter) => filter.selected ? 'true' : 'false',
        'funcFax': (filter: BDCheckboxFilter) => filter.selected ? 'true' : 'false',
        'duplexPrint': (filter: BDCheckboxFilter) => filter.selected ? 'true' : 'false',
        'touchDisplay': (filter: BDCheckboxFilter) => filter.selected ? 'true' : 'false'
    };

    public possiblePrinterQueryParams = {
        'productCategory': () => 'printer',
        'printTechnology': (filter: BDCheckboxFilter) => this.printTechnologyMap[filter.label],
        'printVolumeOpt': (filter: BDSliderFilter) => filter.value,
        'minPrintSpeed': (filter: BDSliderFilter) => filter.value,
        'minTotalPaperFeedNum': (filter: BDRadioFilter) => filter.label,
        'connections': (filter: BDCheckboxFilter) => this.connectionsMap[filter.label],
        'printFormats': (filter: BDCheckboxFilter) => filter.label.toLowerCase(),
        'printerLanguages': (filter: BDCheckboxFilter) => this.printerLanguageMap[filter.label],
        'warrantyOnSite3Years': (filter: BDCheckboxFilter) => filter.selected ? 'true' : 'false',
        'printAirbag': (filter: BDCheckboxFilter) => filter.selected ? 'true' : 'false',
        'funcColorPrint': (filter: BDCheckboxFilter) => filter.selected ? 'true' : 'false',
        'duplexPrint': (filter: BDCheckboxFilter) => filter.selected ? 'true' : 'false',
        'touchDisplay': (filter: BDCheckboxFilter) => filter.selected ? 'true' : 'false'
    };

    public possibleScannerQueryParams = {
        'productCategory': () => 'scanner',
        'minScanVolume': (filter: BDSliderFilter) => filter.value,
        'maxPaperFeedVolume': (filter: BDSliderFilter) => filter.value,
        'connections': (filter: BDCheckboxFilter) => this.connectionsMap[filter.label],
        'scanToFunctions': (filter: BDCheckboxFilter) => this.scanToFunctionsMap[filter.label],
        'scanToPcFormats': (filter: BDCheckboxFilter) => this.scanToPcFormatsMap[filter.label],
        'oneTouchFunction': (filter: BDCheckboxFilter) => filter.selected ? 'true' : 'false',
        'scanTouchScreen': (filter: BDCheckboxFilter) => filter.selected ? 'true' : 'false',
        'scanDuplex': (filter: BDCheckboxFilter) => filter.selected ? 'true' : 'false',
        'automaticFormatRecognition': (filter: BDCheckboxFilter) => filter.selected ? 'true' : 'false',
        'paperFeedViaUltrasound': (filter: BDCheckboxFilter) => filter.selected ? 'true' : 'false',
        'sideStraightening': (filter: BDCheckboxFilter) => filter.selected ? 'true' : 'false',
        'scanOcr': (filter: BDCheckboxFilter) => filter.selected ? 'true' : 'false',
        'imageRotation': (filter: BDCheckboxFilter) => filter.selected ? 'true' : 'false',
        'skipEmptyPage': (filter: BDCheckboxFilter) => filter.selected ? 'true' : 'false'
    };

    public possibleFaxQueryParams = {
        'productCategory': () => 'fax'
    };

    private connectionsMap = {
        'usb': 'USB Anschluss',
        'wlan': 'WLAN Schnittstelle',
        'lan': 'LAN Schnittstelle',
        'wifiDirect': 'Wi-Fi Direct',
        'parallel': 'Parallel Schnittstelle',
        'bluetooth': 'Bluetooth',
        'mobile': 'Verbindung zu Tablet / Mobile',
        'gigabit': 'GIGABIT LAN Schnittstelle',
        'nfc': 'NFC'
    };

    private productDomainMap = {
        'pt': 'P-Touch',
        'ql': 'QL',
        'td': 'TD',
        'vc': 'VC'
    };

    private printTechnologyMap = {
        'laser': 'Laser',
        'ink': 'Tinte'
    };

    private printerLanguageMap = {
        'pcl16': 'PCL6 Emulation',
        'postScript': 'PostScript',
        'ibmProMfcXl': 'IBM ProMFC XL',
        'ibmProPrinterXl': 'IBM ProPrinter XL',
        'epsonFx350': 'Epson FX-350',
        'epsonFx850': 'Epson FX-850',
        'pdf1.7': 'PDF 1.7',
        'xps1.0': 'XPS 1.0'
    };

    private scanToFunctionsMap = {
        'pc': 'Lokaler PC (Dateiordner)',
        'usb': 'USB-Stick / Speichermedium',
        'sd': 'Speicherkarte',
        'image': 'Bildeditor (z. B. Photoshop)',
        'text': 'Texteditor (z. B. Word)',
        'email': 'E-Mail Anhang (über PC)',
        'smb': 'Freigegebener Ordner (SMB)',
        'ftp': 'FTP-Server',
        'emailServer': 'E-Mail Server (POP3)',
        'sharePoint': 'MS-SharePoint',
        'cloud': 'Cloud-Dienste',
        'iphone': 'iPhone',
        'android': 'Android',
        'windowsPhone': 'Windows Phone',
        'printer': 'Drucker'
    };

    private scanToPcFormatsMap = {
        'pdf': 'PDF',
        'tiff': 'TIFF',
        'jpeg': 'JPEG',
        'tiffMultiple': 'TIFF_MULTIPLE',
        'png': 'PNG',
        'pdfSearch': 'Durchsuchbares PDF',
        'pdfCompressed': 'Komprimiertes PDF',
        'pdfSecure': 'Sicheres PDF',
        'pdfPassword': 'Passwortgeschütztes PDF',
        'xps': 'XPS',
        'docx': 'DOCX',
        'pptx': 'PPTX',
        'bmp': 'BMP'
    };

    public constructor() {
        this.addReversedMap(this.connectionsMap);
        this.addReversedMap(this.productDomainMap);
        this.addReversedMap(this.printTechnologyMap);
        this.addReversedMap(this.printerLanguageMap);
        this.addReversedMap(this.scanToFunctionsMap);
        this.addReversedMap(this.scanToPcFormatsMap);
    }

    private addReversedMap(map: { [key: string]: string }): void {
        for (const key of Object.keys(map)) {
            map[map[key]] = key;
        }
    }
}
